/** Données mock rapports mensuels (dossier `monthlyReports/`, à côté de `sharedInterface.tsx`). */
import type { MonthlyReportApi } from "../fleetApi";

export const MONTHLY_REPORTS_MOCK: MonthlyReportApi[] = [
  {
    uuid: "monthly-report-example-1",
    month: "2026-03-31T00:00:00.000Z",
    createdAt: "2026-04-05T14:30:00.000Z",
    sentAt: "2026-04-06T10:00:00.000Z",
    totalMileageGap: 120.1,
    totalMileage: 12000,
    driversConcerned: 4,
    fileName: "rapport_mensuel_mars_2026.pdf",
    bucketFileName: "companies/acme/monthly-reports/2026-03/uuid-1.pdf",
    user: "0124",
    gapPercentage: 20,
  },
  {
    uuid: "monthly-report-example-2",
    month: "2026-02-28T00:00:00.000Z",
    createdAt: "2026-03-03T09:00:00.000Z",
    sentAt: null,
    totalMileageGap: -12.5,
    totalMileage: 9800,
    driversConcerned: 7,
    fileName: "rapport_mensuel_fevrier_2026.xlsx",
    bucketFileName: "companies/acme/monthly-reports/2026-02/uuid-2.xlsx",
    user: "0124",
    gapPercentage: 18,
  },
];
